import { NavListProps, NavSectionProps } from '@aibees/shared/components';
import { stringIncludes } from '@aibees/shared/utils';

export function useFilterMenu(items: NavSectionProps['data'], query: string) {
  if (!query) return items;

  return items
    ?.map((section) => {
      const sectionItems = section.items ?? [];
      const filteredItems = sectionItems.filter((item) => {
        const matchTitle = item.title
          .toLowerCase()
          .includes(query.toLowerCase());
        const matchChild = item.children?.some((child: NavListProps) =>
          stringIncludes(child.title, query)
        );
        return matchTitle || matchChild;
      });

      return {
        ...section,
        items: filteredItems,
      };
    })
    .filter((section) => section.items.length > 0) as NavSectionProps['data'];
}
